// =====================================================================
// Call Inbound (Twilio) — action types
// =====================================================================

export const CALL_INBOUND_LIST = "CALL_INBOUND_LIST";
export const CALL_INBOUND_LIST_SUCCESS = "CALL_INBOUND_LIST_SUCCESS";
export const CALL_INBOUND_LIST_FAIL = "CALL_INBOUND_LIST_FAIL";

export const CALL_INBOUND_LIST_BY_CUSTOMER = "CALL_INBOUND_LIST_BY_CUSTOMER";
export const CALL_INBOUND_LIST_BY_CUSTOMER_SUCCESS =
  "CALL_INBOUND_LIST_BY_CUSTOMER_SUCCESS";
export const CALL_INBOUND_LIST_BY_CUSTOMER_FAIL =
  "CALL_INBOUND_LIST_BY_CUSTOMER_FAIL";

export const CALL_INBOUND_DATA = "CALL_INBOUND_DATA";
export const CALL_INBOUND_DATA_SUCCESS = "CALL_INBOUND_DATA_SUCCESS";
export const CALL_INBOUND_DATA_FAIL = "CALL_INBOUND_DATA_FAIL";

export const CALL_INBOUND_CREATE = "CALL_INBOUND_CREATE";
export const CALL_INBOUND_CREATE_SUCCESS = "CALL_INBOUND_CREATE_SUCCESS";
export const CALL_INBOUND_CREATE_FAIL = "CALL_INBOUND_CREATE_FAIL";
export const CALL_INBOUND_CREATE_RESET = "CALL_INBOUND_CREATE_RESET";

export const CALL_INBOUND_UPDATE = "CALL_INBOUND_UPDATE";
export const CALL_INBOUND_UPDATE_SUCCESS = "CALL_INBOUND_UPDATE_SUCCESS";
export const CALL_INBOUND_UPDATE_FAIL = "CALL_INBOUND_UPDATE_FAIL";
export const CALL_INBOUND_UPDATE_RESET = "CALL_INBOUND_UPDATE_RESET";

export const CALL_INBOUND_DELETE = "CALL_INBOUND_DELETE";
export const CALL_INBOUND_DELETE_SUCCESS = "CALL_INBOUND_DELETE_SUCCESS";
export const CALL_INBOUND_DELETE_FAIL = "CALL_INBOUND_DELETE_FAIL";
export const CALL_INBOUND_DELETE_RESET = "CALL_INBOUND_DELETE_RESET";
